import React, { useState, useEffect } from "react";
import { SiAuthentik } from "react-icons/si";
import Toggle from "../../components/common/toggle";

const Authentication = ({ data, setData }) => {
  const [jwtExpiryHours, setJwtExpiryHours] = useState("");
  const [refreshTokenExpiryDays, setRefreshTokenExpiryDays] = useState("");
  const [allowDownload, setAllowDownload] = useState(true);
  const [allowShare, setAllowShare] = useState(true);

  useEffect(() => {
    if (data && data?.authentication) {
      setJwtExpiryHours(data?.authentication?.jwtExpiryHours || "");
      setRefreshTokenExpiryDays(data?.authentication?.refreshTokenExpiryDays || "");
      setAllowDownload(data?.accessControl?.allowDownload ?? true);
      setAllowShare(data?.accessControl?.allowShare ?? true);
    }
  }, [data?.authentication?.jwtExpiryHours, data?.authentication?.refreshTokenExpiryDays, data?.accessControl?.allowDownload, data?.accessControl?.allowShare]);

  useEffect(() => {
    if (setData && jwtExpiryHours !== undefined) {
      setData(prevData => ({
        ...prevData,
        authentication: {
          ...prevData.authentication,
          jwtExpiryHours: Number(jwtExpiryHours) || 0,
          refreshTokenExpiryDays: Number(refreshTokenExpiryDays) || 0,
        },
        accessControl: {
          ...prevData.accessControl,
          allowDownload,
          allowShare,
        }
      }));
    }
  }, [jwtExpiryHours, refreshTokenExpiryDays, allowDownload, allowShare]);
  console.log("Received data in Authentication:", data?.data);
  console.log("jwtAuthtication", data.authentication);
  console.log("jwtExpire Houssrs:", jwtExpiryHours);
  console.log("refreshTokenExpiryDays:", refreshTokenExpiryDays);

  return (
    <>
      <div className="auth">
        <div className="authentSetting">
          <h4>
            <SiAuthentik /> Authentication Settings
          </h4>
          <p>Control login and token expiry settings</p>

          <div className="body">
            <div className="inputFields">
              <form style={{ gap: "10px" }}>
                <div
                  className="form-header"
                  style={{ display: "flex", gap: "20px", alignItems: "center" }}
                >
                  <div
                    className="text-inputs"
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <div>
                      <label htmlFor="jwtExpiry">JWT Expiry (Hours)</label>
                      <input
                        type="number"
                        id="jwtExpiry"
                        name="jwtExpiryHours"
                        placeholder="..."
                        value={jwtExpiryHours}
                        onChange={(e) => setJwtExpiryHours(e.target.value)}
                        style={{ marginTop: "20px" }}
                      />
                    </div>
                  </div>
                </div>
                <p>How many hours the login token stays valid</p>

                <label htmlFor="refreshTokenExpiry">Refresh Token Expiry (Days)</label>
                <input
                  type="number"
                  id="refreshTokenExpiry"
                  name="refreshTokenExpiryDays"
                  placeholder="Type here..."
                  value={refreshTokenExpiryDays}
                  onChange={(e) => setRefreshTokenExpiryDays(e.target.value)}
                />

                <p>How many days the refresh token remains valid</p>
              </form>
            </div>
          </div>
        </div>

        <div className="authentSetting">
          <h4>
            <SiAuthentik /> Authentication Settings
          </h4>
          <p>Control user permissions for app content</p>
          <div className="body">
            <form action="post">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Allow Download</label>
                  <p>Users can download content</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setAllowDownload(newChecked)}
                  checked={allowDownload}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="label">
                  <label htmlFor="">Allow Share</label>
                  <p>Users can control content</p>
                </div>
                <Toggle
                  onChange={(newChecked) => setAllowShare(newChecked)}
                  checked={allowShare}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authentication;